import React from "react";
import { Zap, Tag, HeartHandshake, ArrowRight, MessageSquareQuote } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1639776739297-f7e1f21526f4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const TRUST = [
  { icon: Zap, label: "Rask diagnostikk" },
  { icon: Tag, label: "Tydelige priser" },
  { icon: HeartHandshake, label: "Personlig service" },
];

export default function Hero() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hjem" className="relative overflow-hidden bg-navy" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          srcSet={`${HERO_IMG.replace("w=1600", "w=800")} 800w, ${HERO_IMG.replace("w=1600", "w=1200")} 1200w, ${HERO_IMG} 1600w`}
          sizes="100vw"
          alt="Reparasjon av elektronikk"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-navy/85" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/60" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 py-20 sm:py-28 lg:py-36">
        <div className="max-w-2xl section-reveal">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-3 py-1 text-xs font-medium uppercase tracking-widest text-warm">
            Verksted i Oslo
          </span>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-white">
            Reparasjon av mobil, PC, Mac og nettbrett
          </h1>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-200 max-w-xl">
            Rask og pålitelig service i Oslo. Vi reparerer telefoner, datamaskiner og
            nettbrett – med tydelige priser og personlig oppfølging.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => go("#bestill")}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-warm px-7 py-3.5 text-base font-semibold text-navy hover:bg-warm-dark active:scale-[0.98] transition-all"
              data-testid="hero-bestill-reparasjon-button"
            >
              Bestill reparasjon <ArrowRight className="w-4 h-4" />
            </button>
            <button
              onClick={() => go("#priser")}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/5 px-7 py-3.5 text-base font-semibold text-white hover:bg-white/10 transition-all"
              data-testid="hero-pristilbud-button"
            >
              <MessageSquareQuote className="w-4 h-4" /> Få et pristilbud
            </button>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {TRUST.map((t) => (
              <div
                key={t.label}
                className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3 backdrop-blur-sm"
                data-testid={`trust-${t.label}`}
              >
                <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-electric/20 text-warm">
                  <t.icon className="w-5 h-5" />
                </span>
                <span className="text-sm font-medium text-white">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
